import React from "react"
import ReactDom from "react-dom";

import styles from "./index.module.scss"

interface ModalContainerProps {
    handleClose: () => void;
    children: React.ReactNode;
    dropShadow: boolean;
}

const ModalContainer: React.FC<ModalContainerProps> = ({ handleClose = () => { }, children, dropShadow }) => {
    return ReactDom.createPortal(
        <div className={styles.modalContainer} >
            <div className={` ${dropShadow ? styles.dropShadow : styles.outside}`} onClick={handleClose}></div>
            {children}
        </div>,
        document.getElementById('modal') as HTMLElement
    );
}
export default ModalContainer;